<template>
    <!-- 生产单详情-工艺单部分 -->
    <div>
        <el-table :data="craftOrder.craftItems" class="craft-order" :row-style="{height: '0'}"
          :cell-style="{'padding':'0px'}" :header-cell-style="{padding: 0}" border>
          <el-table-column v-for="(obj,key,index) in craftItemKeys" :key="index"
            :label="obj.value" :width="obj.width" :prop="key" align="center"/>
        </el-table>
    </div>
</template>

<script>
export default {
  data() {
    return {
      craftOrder: {
        name: '',
        craftRemarks: '',
        craftItems: []
      },
      craftItemKeys: {
        combSection: { value: '梳节', width: 50 },
        materialStandard: { value: '原料规格', width: 80 },
        materialBatch: { value: '原料批号', width: 80 },
        coilLength: { value: '线圈长度(mm/腊克)', width: 130 },
        headVeins: { value: '头纹', width: 80 },
        panHeadNum: { value: '盘头(个)', width: 80 },
        sendYarnFeed: { value: '送纱量', width: 80 },
        padYarnRecord: { value: '垫纱记录', width: '' },
        crossYarnWay: { value: '穿纱方式', width: '' }
      }
    }
  },
  methods: {
    // 设置工艺单信息
    setCraftOrder(rsponse) {
      this.craftOrder = rsponse
    }
  },
  created() {

  }
}
</script>

<style lang="scss" scoped>
.table-input {
  width:100%;height:30px;border:0px;outline:none;padding:0;margin:0;
  text-align: center;
}
.el-button {
    margin:6px 10px 0px 0px
}
</style>
